import { connect } from 'react-redux'

import { RootState } from '../../../store'
import { getAppLoading } from '../../../selectors/app'

/**
 * Import
 * - Actions
 */
import { fetchUserDetail } from '../../../actions'
import { changeNavState } from '../../../actions'

/**
 * Import
 * - Components
 */
import Navbar from '../../../components/common/Navbar/Navbar'

/**
 * Import
 * - Selectors
 */
import { getUserSessionState } from '../../../selectors/user'

const mapStateToProps = (state: RootState) => {
    return {
        loading: getAppLoading(state),
        userSession: getUserSessionState(state),
        userDetail: state.userDetail,
        navbar: state.navBar,
    }
}

export default connect(mapStateToProps, {
    fetchUserDetail: fetchUserDetail,
    changeNavState: changeNavState,
})(Navbar)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/common/Navbar/Navbar.tsx